// extracted by mini-css-extract-plugin
export var actionButton = "_fk-0";
export var attachmentLine = "_fk-1";
export var fileInput = "_fk-2";
export var fileUploadWrapper = "_fk-4";
export var footer = "_fk-3";
export var modalContent = "_fk-5";
export var paperclip = "_fk-6";
export var quillEditor = "_fk-7";